// extracted by mini-css-extract-plugin
export default {"pageNotAuthorized":"NotAuthorized_pageNotAuthorized__SOxJR","content":"NotAuthorized_content__uCCbC","logo":"NotAuthorized_logo__1y1kW","text":"NotAuthorized_text__OoVsx"};